import React from 'react';

import { WrapperFlex } from '@unimed-fesp/components';

import { ContainerEmptyContent } from './styles';

const EmptyContent = () => (
  <WrapperFlex fullHeight justifyCenter alignCenter>
    <ContainerEmptyContent>Nenhum registro localizado</ContainerEmptyContent>
  </WrapperFlex>
);

export default EmptyContent;
